module.exports = __webpack_public_path__ + "img/Carrie_Preston.ef3171f5.jpg";